import { useCallback, useContext, useEffect, useState } from 'react';

import { isNil } from 'ramda';

import { debounce } from 'utils/debounce';

import { LANDING_PAGES_CONTAINER_ID } from './components/Grid';
import LandingPageContext from './contexts/LandingPageContext';

export function useContainerScrollPosition() {
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  const [isScrolling, setIsScrolling] = useState(false);

  const stopScrolling = () => setIsScrolling(false);
  const stopScrollingDebounced = debounce(stopScrolling, 200);

  useEffect(() => {
    const containerEl = document.getElementById(LANDING_PAGES_CONTAINER_ID);
    if (isNil(containerEl)) {
      return;
    }

    const scrollHandler = (evt: any) => {
      const { offsetHeight, scrollTop, scrollHeight } = evt.target;

      if (scrollHeight - offsetHeight === scrollTop) {
        setIsScrolledToBottom(true);
      } else {
        setIsScrolledToBottom(false);
      }

      if (scrollTop < 5) {
        setIsScrolledToTop(true);
      } else {
        setIsScrolledToTop(false);
      }

      if (!isScrolling) {
        setIsScrolling(true);
      }

      stopScrollingDebounced();
    };

    containerEl.addEventListener('scroll', scrollHandler);

    return () => {
      containerEl.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return {
    isScrolledToBottom,
    isScrolledToTop,
    isScrolling,
  };
}

export function useBrandingStyles() {
  const { page } = useContext(LandingPageContext);

  const setColor = useCallback((color: string) => {
    const root = document.documentElement;
    root.style.setProperty('--branding_color', color);
  }, []);

  useEffect(() => {
    if ('brandSettings' in page && page?.brandSettings?.primaryColor) {
      setColor(page?.brandSettings?.primaryColor);
    }

    return () => {
      if ('brandSettings' in page && page?.brandSettings?.primaryColor) {
        setColor('#c99048');
      }
    };
  }, []);
}
